import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const LEADING_FORM_CONTROL_LABEL =
  '& > .MuiFormControlLabel-root:first-of-type';

// A spaced Stack zeroes child margins in Material after 5.8; this
// restores the -11px left and 16px right a leading FormControlLabel had on 5.8.
export const LEADING_FORM_CONTROL_LABEL_MARGIN: SystemStyleObject<Theme> = {
  [LEADING_FORM_CONTROL_LABEL]: { marginLeft: '-11px', marginRight: '16px' },
};
